import React from 'react';
import Button from './Button';

export default function ListPagination({ page, totalPages, total, pageSize = 20, onPageChange, disabled = false, label = 'records', compact = false }) {
  const pages = Math.max(1, totalPages);
  if (compact) return <p className="mb-3 text-right text-sm text-gray-600">Page {page} of {pages}</p>;
  return (
    <nav aria-label={`${label} pagination`} className="mt-4 flex flex-wrap items-center justify-between gap-3">
      <p role="status" className="text-sm text-gray-600">
        Showing {total ? (page - 1) * pageSize + 1 : 0}–{Math.min(page * pageSize, total)} of {total} {label}.
      </p>
      <div className="flex items-center gap-3">
        <Button type="button" variant="outline" disabled={disabled || page <= 1} onClick={() => onPageChange(page - 1)} aria-label={`Previous page of ${label}`}>Previous</Button>
        <span className="text-sm text-gray-600">Page {page} of {pages}</span>
        <Button type="button" variant="outline" disabled={disabled || page >= pages} onClick={() => onPageChange(page + 1)} aria-label={`Next page of ${label}`}>Next</Button>
      </div>
    </nav>
  );
}
